import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import ChecklistTypeMasterContent from "../../components/Masters/ChecklistTypeMaster/ChecklistTypeMasterContent";
import { useDispatch, useSelector } from "react-redux";
const ChecklistTypeMaster = () => {
  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <ChecklistTypeMasterContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default ChecklistTypeMaster;
